import { render, staticRenderFns } from "./ReportePhoneValidationTable.vue?vue&type=template&id=d5c31718&scoped=true&"
import script from "./ReportePhoneValidationTable.vue?vue&type=script&lang=js&"
export * from "./ReportePhoneValidationTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportePhoneValidationTable.vue?vue&type=style&index=0&id=d5c31718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c31718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
